export type Treatment = {
  slug: string;
  title: string;
  image: string;
  list?: string[];
  heading1?: string;
  section1?: string;
  heading2?: string;
  section2?: string;
  heading3?: string;
  section3?: string;
  heading4?: string;
  section4?: string;
  heading5?: string;
  section5?: string;
  listInfo?: string[];
  listSleep?: string[];
  linkSleep?: string;
};

export type StaffMember = {
  name: string;
  position: string;
  image: string;
  description?: string;
};

export type HearingAidSupplier = { name: string; phone: string };

export type AppointmentInfoItem = { title: string; description: string };

export type MenuItem = { label: string; path: string };

export type SiteContent = {
  treatments: Treatment[];
  staff: StaffMember[];
  hearingAidSuppliers: HearingAidSupplier[];
  appointmentInfo: AppointmentInfoItem[];
  header: { menuItems: MenuItem[] };
  hero: { welcome: string; clinicName: string };
  home: { intro: string };
  aboutPage: { title: string; paragraphs: string[] };
  treatmentsPage: { title: string; description: string };
  contactPage: {
    title: string;
    openingHoursLabel: string;
    openingHours: string;
    phoneHoursLabel: string;
    phoneHours: string;
    phoneDisplay: string;
    phoneHref: string;
    emailLabel: string;
    email: string;
    scheduleNote: string;
    mapEmbedUrl: string;
    entrancePhoto: string;
  };
  hearingAidPage: {
    title: string;
    paragraphs: string[];
    supplierIntro: string;
  };
  staffPage: { title: string; description: string };
  appointmentPage: { title: string; description: string };
  treatmentLinkInfo: string;
  letter: {
    title: string;
    subtitle: string;
    clinicName: string;
    address: string;
    phone: string;
    website: string;
    intro: string;
    location: string;
    parking: string;
    allergy: string;
    payment: string;
    cancel: string;
    infection: string;
    closing: string;
    regards: string;
    signature: string;
    clinicClosing: string;
  };
};

export async function fetchContent(): Promise<SiteContent> {
  const res = await fetch("/api/content");
  if (!res.ok) {
    throw new Error(`Failed to load content: ${res.status}`);
  }
  return res.json();
}
